import ReactApexChart from "react-apexcharts";

const chartOptions = {
    chart: {
        toolbar: {
            show: false,
        },
        dropShadow: {
            enabled: false,
        },
    },
    tooltip: {
        theme: "dark",
    },
    dataLabels: {
        enabled: false,
    },
    xaxis: {
        categories: ['Teaching or mentoring', 'Hospitality', 'Technical support', 'Community outreach', 'Music or arts', 'Other'],
        labels: {
            style: {
                colors: "#A3AED0",
                fontSize: "12px",
                fontWeight: "500",
            },
        },
        axisBorder: {
            show: false,
        },
        axisTicks: {
            show: false,
        },
    },
    yaxis: {
        type: "numeric",
        labels: {
            formatter: (label, opts) => {
                const total = opts.w.globals.series[opts.seriesIndex].reduce((sum, x) => {return sum + x;}, 0);
                const val = total > 0 ? parseInt(100 * opts.w.globals.series[opts.seriesIndex][opts.dataPointIndex] / total) : 0;
                return label + ' (' + val + '%)';
            },
            style: {
                colors: "#A3AED0",
                fontSize: "12px",
                fontWeight: "500",
            },
        },
    },
    legend: {
        show: false,
    },
    grid: {
        show: false,
    },
    plotOptions: {
        bar: {
            borderRadius: 4,
            borderRadiusApplication: 'end',
            horizontal: true,
        }
    },
};

const chartData = [
    {
      name: "Households by age range",
      data: [50, 64, 48, 66, 168, 43]
    }
];

function VolunteerGaps() {
    const newOptions = {
        ...chartOptions,
        colors: ["#707EAE"],
    };

    return (
        <>
            <div className="flex-1 relative items-center rounded-[30px] p-[30px] gap-[30px] shadow-atrium shadow-shadow-500 dark:!bg-navy-800 dark:shadow-none">
                {/* header */}
                <div className="flex">
                    <div className="flex-1">
                        <p className="text-gray-800 font-bold dark:text-white">Volunteer gaps</p>
                        <p className="text-gray-600 text-sm">Departments with the highest need for volunteers and members</p>
                    </div>
                </div>

                {/* chart */}
                <div className="block h-[300px]">
                    <div className="h-full w-full">
                        <ReactApexChart
                            options={newOptions}
                            series={chartData}
                            type="bar"
                            width="100%"
                            height="100%"
                        />
                    </div>
                </div>
            </div>

        </>
    );
}

export default VolunteerGaps;
